import logo2 from './logo.png';
import unibenlogo from './uniben-logo.png';
import eng_logo from './eng_logo.jpg';
import ListGroup from 'react-bootstrap/ListGroup';
import { Link } from 'react-router-dom';
import AdvertCard from './AdvertCard';
import black_students from './black_students.jpg';
import './LandingPage.css';

// Fill these in when the ISSNs are issued. Empty values show "Pending".
const ISSN_PRINT = '';
const ISSN_ONLINE = '3141-2742';

const JOURNAL_EMAIL = 'jtvetuniben.fcet@gmail.com';

function LandingPage() {
  return (
    <div className="jt-page">
      <a className="jt-skip" href="#main">Skip to content</a>

      {/* Header */}
      <header className="jt-header">
        <div className="jt-header__inner">
          <div className="jt-brand">
            <div className="jt-brand__logos">
              <img src={logo2} alt="JTVET logo" />
              <img src={unibenlogo} alt="University of Benin logo" />
              <img src={eng_logo} alt="Engineering logo" />
            </div>
            <div>
              <p className="jt-brand__name">JTVET</p>
              <p className="jt-brand__sub">Nigerian Research Journal</p>
            </div>
          </div>

          <nav className="jt-nav" aria-label="Primary">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/published">Published manuscripts</Link></li>
              <li><Link to="/submit" className="jt-nav__cta">Submit manuscript</Link></li>
            </ul>
          </nav>
        </div>
      </header>

      <main id="main">
        {/* Hero */}
        <section className="jt-hero">
          <div className="jt-hero__inner">
            <div className="jt-hero__text">
              <h1> About JTVET</h1>
              <p className="jt-hero__lead">
                 {/* Introductory Text */}

              JTVET is domiciled in the School of Technology Education, Federal College of Technical Education Asaba, Nigeria. 
              It provides a platform for the dissemination of novel research findings and state-of-the-art research. 
              JTVET adopts the open access model of publication by considering research as a collaborative effort.
              The scope of the journal includes but is not limited to the following areas:
              Technical, Business and Vocational Education (TVET)
              
              </p>
              <div className="jt-hero__actions">
                
                <Link to="/published" className="jt-btn jt-btn--ghost">
                  Read published papers
                </Link>
              </div>
            </div>

            <div className="jt-hero__ad">
              <AdvertCard
                title="Advertisement board"
                image={black_students}
                description="Your advert will go here!"
                link="#"
              />
            </div>
          </div>
        </section>

        {/* About + sidebar */}
        <section className="jt-section jt-body">
          <article className="jt-article">
            <h1>Mission Statement</h1>
            <p>
              Our mission is to foster a dynamic and collaborative academic community by providing a platform for the 
              publication of insightful articles,  promoting relevant conferences, and highlighting the impactful work of faculty members. 
              We aim to support knowledge sharing, intellectual growth, and professional by engagement, helping to advance research 
              and scholarly discourse in a wide range of fields.
            </p>
          
           
            <Link to="/login" className="jt-btn jt-btn--dark">
              Submit a manuscript
            </Link>
          </article>

          <aside className="jt-aside">
            <h2>Journal details</h2>
            <dl className="jt-meta">
              
              <div>
                <dt>E-ISSN (online)</dt>
                <dd>{ISSN_ONLINE || 'Pending'}</dd>
              </div>
              <div>
                <dt>DOI</dt>
                <dd>Provided in partnership with Zenodo</dd>
              </div>
            </dl>

            <h2>Indexed in</h2>
            <ListGroup variant="flush" className="jt-index">
              <ListGroup.Item>Zenodo</ListGroup.Item>
            </ListGroup>
          </aside>
        </section>

        {/* Editors */}
        <section className="jt-editors">
          <div className="jt-section">
            <h2>Journal editors</h2>
            <div className="jt-editors__grid">
              <div className="jt-person">
                <h3>Editor-in-Chief</h3>
                <p className="jt-person__name">Prof. Ekemini E. Uko-Aviomoh</p>
                <p>Dean, Faculty of Technical/Vocational Education, University of Benin, Nigeria</p>
              </div>

              <div className="jt-person">
                <h3>Site Manager</h3>
                <p className="jt-person__name">Dr. Vincent Aimayo</p>
                <p>Dean, School of Technology Education, Federal College of Technical Education Asaba, Nigeria</p>
              </div>

              <div className="jt-person">
                <h3>Peer Review Co-ordinator</h3>
                <p className="jt-person__name">Dr. S. O. Omorodion</p>
                <p>School of Technology Education, Federal College of Technical Education Asaba</p>
                <p className="jt-person__contact">
                  Send all correspondence to{' '}
                  <a>{JOURNAL_EMAIL}</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="jt-footer">
        <div className="jt-footer__inner">
          <p>
            Copyright © 2026 Journal of Technical and Vocational Education and
            Training. All rights reserved.
          </p>
          <p>
            Designed and developed by <a href="#">ISITEC</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
